import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

@Injectable()
export class EventHttpInterceptor implements HttpInterceptor {
    constructor() {}

    intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers = req.headers
            .set('event', '2463bf18-9480-4d1c-a58f-33696e3c7f96');
            // .append('Content-Type', 'application/json');
        const authReq = req.clone({headers: headers});
        return next.handle(authReq);
    }
}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/interceptors/eventHttp.interceptor.ts